/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';

import Materiel from '../utils/Interface/Materiel';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';
import apiGLPIRoutes from '../utils/hooks/apiGLPIRoutes';

import InputField from '../components/InputField';
import Button from '../components/Button';
import ButtonSave from '../components/ButtonSave';
import TableModal from '../components/TableModal';
import { isTokenPresent } from '../utils/auth';
import User from "../utils/Interface/User";
import InputSelect from '../components/InputSelect';
import TableSimpleModalMateriel from '../components/TableSimpleModalMateriel';

import '../style/css/newattribution.css';


interface NewAttributionProps {
  isUserAlreadySelected: boolean;
  User?: User | null;
  handleCancel: () => void;
  location: string;
}


  const NewAttribution: React.FC<NewAttributionProps> = ({isUserAlreadySelected, User, handleCancel, location}) => {

const [selectedUser, setSelectedUser] = useState<User | null>(null);
const [selectedMateriel, setSelectedMateriel] = useState<Materiel | null>(null);
const [data3, setData] = useState<User[]>([]);
const { userName, specialToken } = useSpecialToken();
const [dataComputer, setDataComputer] = useState<Materiel[]>([]);
const [dataPhone, setDataPhone] = useState<Materiel[]>([]);
const [dataMonitor, setDataMonitor] = useState<Materiel[]>([]);
const [basicModal1, setBasicModal1] = useState(false);
const [basicModal2, setBasicModal2] = useState(false);
const [AttributionType, setAttributionType] = useState('');
const [AttributionUserName, setAttributionUserName] = useState('');
const [AttributionEntity, setAttributionEntity] = useState('');
const [AttributionSerial, setAttributionSerial] = useState<string>('');
const[AttributionMaterielName, setAttributionMaterielName] = useState<string>('');
const [AttributionCommentary, setAttributionCommentary] = useState<string>('');
const [selectedValue, setSelectedValue] = useState(0);
const [searchValue, setSearchValue] = useState<string>('');
const [searchValue2, setSearchValue2] = useState<string>('');
const [searchValueMat, setSearchValueMat] = useState<string>('');
const [searchValueMat2, setSearchValueMat2] = useState<string>('');
const [filteredData, setFilteredData] = useState<User[]>([]);
const [filteredDataMat, setFilteredDataMat] = useState<Materiel[]>([])
const [Visible, setVisible] = useState(false);
const [Visible2, setVisible2] = useState(false);
const [materielUserId, setMaterielUserId] = useState<number>(0);
const [selectedUserId, setSelectedUserId] = useState<string>('');
const options = [{ text: 'Ordinateur', id: 0 }, { text: 'Téléphone', id:1 }, { text: 'Moniteur', id:2 }];



  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/';
    } else if (specialToken){
    fetchData();
    fetchDataComputer();
    fetchDataMonitor();
    fetchDataPhone();}
  }, [specialToken]);

  useEffect(() => {
    if (isUserAlreadySelected && User) {
      console.log(User, "user")
      setSelectedUser(User);
      setAttributionUserName(User.user_realname);
      setAttributionEntity(User.entity_name)
    }
  }, [isUserAlreadySelected, User]);


  async function fetchData(): Promise<void> {

    try {

        const token = localStorage.getItem('sessionToken');

        if (!token) {
            throw new Error('Token not found in local storage');
        }

         if (!specialToken) {
      throw new Error('Special token is null or undefined');
        }
  
        const response = await fetch(apiRoutes.UsersGetAll, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'special-token': specialToken,
               
            },
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la récupération des données');
        }

        const jsonData = await response.json();
   
        setData(jsonData);
        setFilteredData(jsonData);

    } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
    }

}


  async function fetchDataComputer(): Promise<void> {

    try {

        const token = localStorage.getItem('sessionToken');

        if (!token) {
            throw new Error('Token not found in local storage');
        }

        const response = await fetch(apiGLPIRoutes.computerGetAll, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Session-Token': token,
            },
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la récupération des données');
        }

        const jsonDataComputer = await response.json();

        const modifiedDataComputer = jsonDataComputer.map((computer: any) => ({
            ...computer,
            manufacturer_id: computer.manufacturers_id,
        }));

        setDataComputer(modifiedDataComputer);

    } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
    }

  }
  async function fetchDataPhone(): Promise<void> {

  try {

      const token = localStorage.getItem('sessionToken');

      if (!token) {
          throw new Error('Token not found in local storage');
      }

      const response = await fetch(apiGLPIRoutes.phoneGetAll, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'Session-Token': token,
          },
      });

      if (!response.ok) {
          throw new Error('Erreur lors de la récupération des données');
      }

      const jsonDataPhone: Materiel[] = await response.json();
     

      setDataPhone(jsonDataPhone);

  } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
  }

  }

  async function fetchDataMonitor(): Promise<void> {

  try {

      const token = localStorage.getItem('sessionToken');

      if (!token) {
          throw new Error('Token not found in local storage');
      }

      const response = await fetch(apiGLPIRoutes.monitorGetAll, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'Session-Token': token,
          },
      });

      if (!response.ok) {
          throw new Error('Erreur lors de la récupération des données');
      }

      const jsonDataMonitor: Materiel[] = await response.json();
  
      setDataMonitor(jsonDataMonitor);

  } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
  }

  }


  function handleUserSelection(user: User) {
    setSelectedUser(user);
    toggleModal1();
    setAttributionUserName(user.user_realname);
    setAttributionEntity(user.entity_name)
  }

  const handleSearch = () => {
  const searchTerm = searchValue.toLowerCase().trim();
  const filteredData = data3.filter((user) => {
    const nameMatch = user.user_name && user.user_name.toLowerCase().includes(searchTerm);
    const firstnameMatch = user.user_firstname && user.user_firstname.toLowerCase().includes(searchTerm);
    const realnameMatch = user.user_realname && user.user_realname.toLowerCase().includes(searchTerm);
    return nameMatch || firstnameMatch || realnameMatch;
  });
  setFilteredData(filteredData);
  setVisible(true);
  };

  const handleSearch2 = () => {
    const searchTerm = searchValue2.toLowerCase().trim();
    const filteredData = data3.filter((user) => {
      const nameEntityMatch = user.entity_name && user.entity_name.toLowerCase().includes(searchTerm);
      return nameEntityMatch;
    });
    setFilteredData(filteredData);
    setVisible(true);
  };

// Fonction pour effacer les recherches
  const handleClearSearch = () => {
    setSearchValue('');
    setSearchValue2('');
    setFilteredData(data3);
    setVisible(false);
  };

  const handleSearchMat = () => {

    const searchTerm = searchValueMat.toLowerCase().trim().replace(/\s+/g, '');

    let dataToFilter: any[] = [];

    if (selectedValue === 0) {
    dataToFilter = dataComputer;
    } else if (selectedValue === 1) {
    dataToFilter = dataPhone;
    } else if (selectedValue === 2) {
    dataToFilter = dataMonitor;
    }

    const filteredDataMat = dataToFilter.filter((materiel) => {
  
    if (!materiel.serial) {
      return false;}
      return materiel.serial.toLowerCase().replace(/\s+/g, '').includes(searchTerm);
      });
      setFilteredDataMat(filteredDataMat);
      setVisible2(true);
    };

  const handleSearchMat2 = () => {

    const searchTerm = searchValueMat2.toLowerCase().trim().replace(/\s+/g, '');

    let dataToFilter: any[] = [];

    if (selectedValue === 0) {
      dataToFilter = dataComputer;
    } else if (selectedValue === 1) {
      dataToFilter = dataPhone;
    } else if (selectedValue === 2) {
     dataToFilter = dataMonitor;
    }

    const filteredDataMat = dataToFilter.filter((materiel) => {
      return materiel.name.toLowerCase().replace(/\s+/g, '').includes(searchTerm);
    });

    setFilteredDataMat(filteredDataMat);
    setVisible2(true);
  };

  const handleClearSearchMat = () => {
    setSearchValueMat('');
    setSearchValueMat2('');
    setFilteredDataMat([]);
    setVisible2(false);
  };

  const handleMaterielSelection = (materiel: Materiel) => {
    setSelectedMateriel(materiel);
    setAttributionSerial(materiel.serial);
    setAttributionMaterielName(materiel.name)
    setMaterielUserId(materiel.glpi_user_id ||0)
    toggleModal2();
  };

  const toggleModal1 = () => {
    setBasicModal1(!basicModal1);
  };

  const toggleModal2 = () => {
    setBasicModal2(!basicModal2);
  };

  const handleclick = () => { console.log("click"); };

  const handleSelectChange = (value: number) => {

    setSelectedValue(value);

    if(value===0) {
      setAttributionType("Ordinateur")
    }
    if(value===1) {
      setAttributionType("Téléphone")
      }
    if(value===2) {
      setAttributionType("Monitor")
      }
    };

  const handleSave = async () => {

    try {

        const token = localStorage.getItem('sessionToken');

        if (!token) {
            throw new Error('Token not found in local storage');
        }

        if (!specialToken) {
            throw new Error('Special token is null or undefined');
        }

        if(materielUserId && materielUserId !== 0 && materielUserId !== 5) {
          alert(`Le matériel est déja attribué, veuillez choisir un autre matériel ( ${materielUserId})`)
        }  else {

          const currentDate = new Date().toISOString().split('T')[0]; // Format "YYYY-MM-DD"


        let attributionData = {};

        if (selectedValue === 0 && selectedMateriel) {
            attributionData = {
                glpi_user_id_tech: 2,
                glpi_user_id: selectedUser?.user_id || 0,
                glpi_entities_id: selectedUser?.entity_id || 0,
                attribution_date: currentDate,
                return_date: currentDate,
                commentary: AttributionCommentary,
                state: 'attributed',
                glpi_computer_id: selectedMateriel?.id || null,

            };
        } else if (selectedValue === 1 && selectedMateriel) {
            attributionData = {
                glpi_user_id_tech: 2,
                glpi_user_id: selectedUser?.user_id || 0,
                glpi_entities_id: selectedUser?.entity_id || 0,
                attribution_date: currentDate,
                return_date: currentDate,
                commentary: AttributionCommentary,
                state: 'attributed',
                glpi_phones_id: selectedMateriel?.id || null,
            };
        } else if (selectedValue === 2 && selectedMateriel) {
            attributionData = {
                glpi_user_id_tech: 2,
                glpi_user_id: selectedUser?.user_id || 0,
                glpi_entities_id: selectedUser?.entity_id || 0,
                attribution_date: currentDate,
                return_date: currentDate,
                commentary: AttributionCommentary,
                state: 'attributed',
                glpi_monitors_id: selectedMateriel?.id || null,
            };
        } else {
            throw new Error('Veuillez sélectionner un matériel valide (ordinateur, téléphone ou moniteur)');
        }

        const response = await fetch(apiRoutes.attributionsPost, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'special-token': specialToken
            },
            body: JSON.stringify(attributionData),
        });

        if (!response.ok) {
            throw new Error('Erreur lors de l\'envoi des données');
        }

        // 2.Send glpi_user_id to material's table API GLPI

        const bodyData = JSON.stringify({ "input": { "glpi_user_id": selectedUser?.user_id }});
  

        let url;

        switch (selectedValue) {
            case 0:
                url = apiGLPIRoutes.computerPut.replace(':materielId', `${selectedMateriel.id}`);
                break;
            case 1:
                url = apiGLPIRoutes.phonePut.replace(':materielId', `${selectedMateriel.id}`);
                break;
            case 2:
                url = apiGLPIRoutes.monitorPut.replace(':materielId', `${selectedMateriel.id}`);
                break;
            default:
                throw new Error('Invalid selected value');
        }

        const responseGLPI = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Session-Token': token,
            },
            body: bodyData,
        });

        if (!responseGLPI.ok) {
            throw new Error('Erreur lors de l\'envoi du glpi_user_id vers l\'API GLPI');
        }

        alert('Attribution créée avec succès !')

        setAttributionType('');
        setAttributionUserName('');
        setAttributionEntity('');
        setAttributionSerial('');
        setAttributionCommentary('');
        setSelectedUser(null);
        setSelectedMateriel(null);

        window.location.href = `${location}`; 

    }} catch (error) {
        console.error('Erreur lors de l\'envoi des données :', error);
    }
};

  const handleClickMatSearch = () => {
    toggleModal2()
    setAttributionType("Ordinateur")
    setSelectedValue(0)
  };

  const handleCancelled = () => {
   handleCancel()
  }

  return (
    <div className="mainnewatt">
      
        <div className="mainnewatt__searcharea">

            <div className="mainnewatt__searcharea__user">
              

              <Button btnName="Rechercher un utilisateur" onClick={toggleModal1} disable={false} />

              <MDBModal id="ModalUser" open={basicModal1} onClose={() => setBasicModal1(false)} tabIndex='-2'>
                <MDBModalDialog size="lg" id="modaluserdialog">
                  <MDBModalContent id="modalcontentuser">
                    <MDBModalHeader id="modalheader">
                      <MDBModalTitle id="modalusertitle">Recherche d'utilisateur</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleModal1}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody id="modalbodyuser">
                      <div id="modalbodyuserform">
                        <InputField
                        labels={[{ title: 'Entité' }]}
                        onChange={(newValue) => setSearchValue2(newValue[0])}
                        initialValue={[searchValue2]}
                        readOnly={false} />
                        <InputField
                        labels={[{ title: 'Utilisateur' }]}
                        onChange={(newValue) => setSearchValue(newValue[0])}
                        initialValue={[searchValue]}
                        readOnly={false}/>
                        <div id="newatt" >
                          <Button btnName="RECHERCHER" onClick={() => searchValue2 ? handleSearch2() : handleSearch()} disable={false}/>
                            <div className={Visible ? "" : "effacer"}>   
                               <Button btnName="EFFACER" onClick={handleClearSearch} disable={false}/>
                            </div>
                        </div>
                      </div>
                      <TableModal 
                      users={filteredData} 
                      onUserSelect={handleUserSelection} />
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

            </div>

            <div className="mainnewatt__searcharea__materiel">


              <Button btnName="Rechercher un matériel" onClick={handleClickMatSearch} disable={false} />

              <MDBModal id="ModalUser" open={basicModal2} onClose={() => setBasicModal2(false)} tabIndex='-2'>
                <MDBModalDialog size="lg" id="modaluserdialog">
                  <MDBModalContent id="modalcontentuser">
                    <MDBModalHeader id="modalheader">
                      <MDBModalTitle id="modalusertitle">Rechercher matériel à attribuer</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleModal2}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody id="modalbodyuser">
                      <InputSelect 
                      selectedKey={2}
                      options={options}
                      onChange={handleSelectChange}
                      classValue={1} />
                      {selectedValue === 0 && (
                        <div id="modalbodyuserform__computer">
                          <div id="modalbodyuserform">
                            <InputField 
                              labels={[{ "title": "Numéro de série" }]} 
                              initialValue={[searchValueMat]} 
                              onChange={newValues => setSearchValueMat(newValues[0])} />
                            <InputField 
                              labels={[{ "title": "Nom Ordinateur" }]} 
                              initialValue={[searchValueMat2]} 
                              onChange={newValues => setSearchValueMat2(newValues[0])}/>
                                <div id="newatt">  
                                  <Button btnName="RECHERCHER" onClick={() => searchValueMat2 ? handleSearchMat2() : handleSearchMat()} disable={false}/>
                                    <div className={Visible2 ? "" : "effacer"}>
                                       <Button btnName="EFFACER" onClick={handleClearSearchMat} disable={false} />
                                     </div>
                                </div>
                          </div> 
                          <div id="tablematmodalsearch"> 
                          <TableSimpleModalMateriel 
                          materiels={filteredDataMat.length > 0 ? filteredDataMat : dataComputer} 
                          onMaterielSelect={handleMaterielSelection} />
                          </div> 
                        </div>
                      )}  

                      {selectedValue === 1 && (
                      <div id="modalbodyuserform__phone">
                          <div id="modalbodyuserform">
                            <InputField 
                              labels={[{ "title": "Numéro de série" }]} 
                              initialValue={[searchValueMat]} 
                              onChange={newValues => setSearchValueMat(newValues[0])} />
                            <InputField 
                              labels={[{ "title": "Nom Téléphone" }]} 
                              initialValue={[searchValueMat2]}
                              onChange={newValues => setSearchValueMat2(newValues[0])} />
                                <div id="newatt">  
                                  <Button btnName="RECHERCHER" onClick={() => searchValueMat2 ? handleSearchMat2() : handleSearchMat()} disable={false} />
                                    <div className={Visible2 ? "" : "effacer"}>
                                      <Button btnName="EFFACER" onClick={handleClearSearchMat} disable={false} />
                                    </div>

                                </div>
                          </div> 
                        <div id="tablematmodalsearch"> 
                          <TableSimpleModalMateriel 
                          materiels={filteredDataMat.length > 0 ? filteredDataMat : dataPhone} 
                          onMaterielSelect={handleMaterielSelection} />
                        </div>
                      </div>
                      )}

                      {selectedValue === 2 && (
                        <div id="modalbodyuserform__monitor">
                          <div id="modalbodyuserform">
                            <InputField 
                            labels={[{ "title": "Numéro de série" }]} 
                            initialValue={[searchValueMat]} 
                            onChange={newValues => setSearchValueMat(newValues[0])} />
                            <InputField 
                            labels={[{ "title": "Nom Moniteur" }]} 
                            initialValue={[searchValueMat2]} 
                            onChange={newValues => setSearchValueMat2(newValues[0])}/>
                              <div id="newatt">  
                                <Button btnName="RECHERCHER" onClick={() => searchValueMat2 ? handleSearchMat2() : handleSearchMat()} disable={false}/>
                                  <div className={Visible2 ? "" : "effacer"}>
                                    <Button btnName="EFFACER" onClick={handleClearSearchMat} disable={false}/>
                                  </div>
                              </div>
                          </div>   
                          <div id="tablematmodalsearch"> 
                            <TableSimpleModalMateriel 
                            materiels={filteredDataMat.length > 0 ? filteredDataMat : dataMonitor} 
                            onMaterielSelect={handleMaterielSelection} />
                          </div>
                        </div>
                      )}
                    </MDBModalBody>
                    <MDBModalFooter>
                      <ButtonSave btnName='Enregistrer' onClick={handleclick} />
                      <Button btnName='Annuler' onClick={handleCancel} disable={false} />
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

            </div>

        </div>

        <div className="mainnewatt__form">

            <h4 className="mainnewatt__form__title">Champs personnalisés</h4>
            
            <div className="mainnewatt__form__inputs">
             
              <InputField 
              labels={[{ "title": "Type" }]} 
              onChange={newValue => setAttributionType(newValue[0])} 
              initialValue={[AttributionType]} />

              <InputField 
              labels={[{ "title": "Nom" }]} 
              onChange={newValue => setAttributionUserName(newValue[0])} 
              initialValue={[AttributionUserName]} />

              <InputField 
              labels={[{ "title": "Entité" }]} 
              onChange={newValue => setAttributionEntity(newValue[0])} 
              initialValue={[AttributionEntity]} />

              <InputField 
              labels={[{ "title": "Nom matériel" }]} 
              onChange={newValue => setAttributionMaterielName(newValue[0])} 
              initialValue={[AttributionMaterielName]} />

              <InputField 
              labels={[{ "title": "Numéro de série" }]} 
              onChange={newValue => setAttributionSerial(newValue[0])} 
              initialValue={[AttributionSerial]} />

              <InputField 
              labels={[{ "title": "Commentaire" }]} 
              onChange={newValue => setAttributionCommentary(newValue[0])} 
              initialValue={[AttributionCommentary]} />

            </div>

            <div className="mainnewatt__form__btns">

              <Button btnName="Annuler" onClick={handleCancelled} disable={false}/>
              <Button btnName="Sauvegarder" onClick={handleSave} disable={false}/>
              
            </div>

        </div>

    </div>
  );
}

export default NewAttribution;
